export default {
  API_URL: process.env.REACT_APP_API_SERVER ? process.env.REACT_APP_API_SERVER : 'https://myhealth-api.dev.notenetic.com/api',
};
